import ApplicationModel, { attr } from '../ApplicationModel';
import { type MeetingAttendeeAttributes } from './generated/MeetingAttendeeAttributes';
import { model } from '../modelBuilder';

interface MeetingAttendee extends MeetingAttendeeAttributes {}

@model
class MeetingAttendee extends ApplicationModel {
  // Start auto-generated
  static typename: 'MeetingAttendee' = 'MeetingAttendee';
  get typename(): 'MeetingAttendee' {
    return 'MeetingAttendee';
  }

  static internalTypename: 'MeetingAttendee' = 'MeetingAttendee';
  get internalTypename(): 'MeetingAttendee' {
    return 'MeetingAttendee';
  }

  static fields = {
    createdAt: attr({ readable: true }),
    email: attr({ readable: true }),
    guest: attr({ readable: true }),
    id: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    userId: attr({ readable: true }),
    attendable: attr.belongsTo({
      readable: true,
      typename: ['NoteTemplate', 'Page', 'Unimplemented'],
    }),
    pageShareLink: attr.belongsTo({
      readable: true,
      typename: 'PageShareLink',
    }),
    sharedPage: attr.belongsTo({ readable: true, typename: 'SharedPage' }),
    user: attr.belongsTo({ readable: true, typename: 'User' }),
  };
  // End auto-generated
}

export default MeetingAttendee;
